export const formScrollIntoViewOptions = {
  canSubmitWhenInvalid: true,
  onSubmitInvalid: () => {
    window.document.querySelector('[aria-invalid="true"]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  },
};
